<span class="text" title="{{visualField().shortTitle}}" [class.bold]="visualField().sorted()">
  {{visualField().shortTitle}}
</span>
<span class="column-sort-indicator-container ag-sort-indicator-icon d-flex" [hidden]="!visualField().sorted()">
  <span class="ag-icon" [class.ag-icon-asc]="sortingAscending()" [class.ag-icon-desc]="!sortingAscending()" role="presentation" unselectable="on"></span>
</span>
<span class="ag-header-icon ag-header-cell-menu-button ag-header-menu-icon ag-header-menu-always-show column-group-header-ellipsis"
      (click)="ellipsisClick.emit($event)">
  <span class="ag-icon ag-icon-menu-alt" role="presentation" unselectable="on"></span>
</span>